import { render, staticRenderFns } from "./LogAdminBody.vue?vue&type=template&id=fe415868&"
import script from "./LogAdminBody.vue?vue&type=script&lang=ts&"
export * from "./LogAdminBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports